import React, { forwardRef } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const CustomizedCheckboxes = forwardRef(
  ({ sx, value, isDisabled, onChange, label, error, testId }, ref) => {
    return (
      <FormControlLabel
        ref={ref}
        control={
          <Checkbox
            data-test-id={testId}
            checked={value}
            value={value}
            disabled={isDisabled}
            onChange={onChange}
            sx={{ ...sx, color: error ? "error.main" : "primary.main" }}
          />
        }
        label={label}
      />
    );
  }
);

export default CustomizedCheckboxes;
